<mat-slide-toggle
	color="primary"
	[hideIcon]="false"
	data-cy="feedback-hold"
	[(ngModel)]="selectedService.getActivity().is_feedback_published"
	(change)="toggleFeedbackHold()">
	{{'activity-list_activity-options-menu-publish-feedback-and-grades' | translate}}
</mat-slide-toggle>
<mat-icon
	tabindex="0"
	class="ficon-app-help-circle-outline"
	[attr.aria-label]="'activity-list_activity-options-menu-publish-feedback-and-grades-help' | translate"
	[matTooltip]="'activity-view_feedback-hold-tooltip' | translate"
	matTooltipClass="multi-line-tooltip"
	matTooltipPosition="below">
</mat-icon>

